import {useEffect,useState,useCallback} from 'react';
import {crmAPI,useCRMAuth,apiError} from '../context/CRMAuthContext';
import {watchLiveRefresh} from '../../hooks/liveRefresh';

export const useCustomerRecords=(path,params={})=>{
  const {user,effective_permissions=[]}=useCRMAuth();
  const [result,setResult]=useState({loading:true,data:null,error:''});
  const [revision,setRevision]=useState(0);
  const reload=useCallback(()=>setRevision(value=>value+1),[]);
  const parameters=JSON.stringify(params);
  const identity=JSON.stringify([user?.id,user?.tenant_id,user?.role,effective_permissions]);
  useEffect(()=>{
    const controller=new AbortController();
    let active=true,pending=false;
    setResult({loading:true,data:null,error:''});
    const refresh=()=>{
      if(pending||!active)return;
      pending=true;
      crmAPI.get(path,{params:JSON.parse(parameters),signal:controller.signal,timeout:20000}).then(({data})=>{
      if(active)setResult({loading:false,data,error:''});
    }).catch(error=>{
      if(!active)return;
      const message=error.response?.status===404?'Müşteri kaydı bulunamadı.':error.response?.status===403?'Bu müşteri kaydını görüntüleme yetkiniz yok.':apiError(error);
      setResult({loading:false,data:null,error:message});
      }).finally(()=>{pending=false;});
    };
    refresh();
    const stop=watchLiveRefresh(refresh);
    return()=>{active=false;stop();controller.abort();};
  },[path,parameters,identity,revision]);
  return {...result,reload};
};